var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1118_274326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18C14.4706 18 18.5 13.9706 18.5 9C18.5 4.02944 14.4706 0 9.5 0C4.52944 0 0.5 4.02944 0.5 9C0.5 13.9706 4.52944 18 9.5 18Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0033 11.6031L13.402 9.00093H10.9061V7.31256C10.9061 6.60127 11.2542 5.90643 12.373 5.90643H13.5083V3.69155C13.5083 3.69155 12.4781 3.51562 11.4934 3.51562C9.43797 3.51562 8.09386 4.76102 8.09386 7.01766V9.00093H5.80811V11.6031H8.09386V17.8921C8.55202 17.9642 9.02158 18.0009 9.49999 18.0009C9.9784 18.0009 10.448 17.963 10.9061 17.8921V11.6031H13.0033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1118_274326"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.d046a1ce0d8a8abcbe6e0813e077264e.svg";
export { ForwardRef as ReactComponent };